/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));
    //console.log('Init Function Called');
    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      // this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

      if (!getActUserCookie('isACTUser')) {
        const rewardSections = document.querySelectorAll(".discount-reward-bar");
        rewardSections.forEach(rewardSection => {
          rewardSection.style.display = 'none';
        });

        // Remove the custom cart drawer section if it exists
        const drawerSections = document.querySelectorAll(".custom-cart-drawer1");
        drawerSections.forEach(drawerSection => {
          drawerSection.style.display = "none";
        });
        const cartWrapers = document.querySelectorAll(".theme-ajax-cart");
        cartWrapers.forEach(cartWraper => {
          if(cartWraper && !cartWraper.classList.contains('drawer-without-reward')){
              cartWraper.classList.add('drawer-without-reward');
            } 
        });
      } else {
        const cartContentWrappers = document.querySelectorAll(".ajax_cart_content");
        if(cartContentWrappers){
          cartContentWrappers.forEach(cartContentWrapper => {
            if(cartContentWrapper && !cartContentWrapper.classList.contains('is-atc-user')){
              cartContentWrapper.classList.add('is-atc-user');
            }  
          });
        }
      }
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    //console.log('showMiniCartOnHover function called');
    
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    //console.log('hideMiniCart function called');
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    //console.log('toggleMiniCart function called');
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      // window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    //console.log('showDrawer function called');
    if (!document.body.classList.contains("atc-user-activate")) {
      window.location.href = document.location.origin +
        window.Shopify?.routes?.root +
        "cart/";
      return false;
    }
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('html').addClass('cart_popup_visible');
    var $lightbox = $('.quick-shop__lightbox');
    if ($lightbox.hasClass('fancybox-is-open')) {
      // Remove the 'fancybox-is-open' class
      $lightbox.removeClass('fancybox-is-open');

      // Remove the 'display' inline style from the inner popup
      $lightbox.find('.quick-shop__popup').css('display', '');
      var flickityInstance = $lightbox.flickity();
      flickityInstance.resize();
    }
  },
  hideDrawer: function () {
    //console.log('hideDrawer function called');
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('html').removeClass('cart_popup_visible');
  },
  removeFromCart: function (lineID, callback) {
    //console.log('removeFromCart function called');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        if(rewardBlocks){
      window.PXUTheme.jsAjaxCart.updateGiftProducts(rewardBlocks);
    }
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {
  //console.log('initializeAjaxCart function called');
    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }
        if(rewardBlocks){
      window.PXUTheme.jsAjaxCart.updateGiftProducts(rewardBlocks);
    }
        if (crossSellBlock && crossSellBlock.products && crossSellBlock.products.length > 0) {
          const crossSellProducts = crossSellBlock.products;
          renderCrossSellProductElement(crossSellProducts);
        }
        // if(rewardBlocks){
        //   updateMultiRewardsBar(rewardBlocks);
        // }
        window.PXUTheme.jsAjaxCart.updateView();
      })
      .fail(() => {
        // some error handling
      });
  },
  testfunction: function (){
    //console.log('test function called');
  },
  initializeAjaxCartOnMobile: function () {
  //console.log('initializeAjaxCartOnMobile function called');

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
  //console.log('addToCart function called');
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {

          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          window.PXUTheme.jsAjaxCart.showDrawer();
          if(rewardBlocks){
            window.PXUTheme.jsAjaxCart.updateGiftProducts(rewardBlocks);
          }
          window.PXUTheme.jsAjaxCart.updateView();

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

          $('.warning').remove();

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {
  //console.log('updateView function called');
  /*$('.ajax_cart_content').addClass('cart-loading');*/
  // //console.log("ajax_cart_content added1")
    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        const drawerSections1 = document.querySelectorAll(".custom-cart-drawer1");
        const rewardSections1 = document.querySelectorAll(".discount-reward-bar");
        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        if(rewardSections1){
          rewardSections1.forEach(rewardSection => {
            if(rewardSection.classList.contains('hide')){
              rewardSection.classList.remove('hide');
            }
          });
        }
        if(drawerSections1){
          drawerSections1.forEach(drawerSection => {
            if(drawerSection.classList.contains('hide')){
              drawerSection.classList.remove('hide');
            }
          });
        }

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
        const drawerSections1 = document.querySelectorAll(".custom-cart-drawer1");
        const rewardSections1 = document.querySelectorAll(".discount-reward-bar");
        if(rewardSections1){
          rewardSections1.forEach(rewardSection => {
            if(!rewardSection.classList.contains('hide')){
              rewardSection.classList.add('hide');
            }
          });
        }
        if(drawerSections1){
          drawerSections1.forEach(drawerSection => {
            if(!drawerSection.classList.contains('hide')){
              drawerSection.classList.add('hide');
            }
          });
        }
      }
      
      if(rewardBlocks){
        // updateGiftProducts(rewardBlocks);
        updateMultiRewardsBar(rewardBlocks);
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
      initOrReinitCrossSellSliders();
     /* $('.ajax_cart_content').removeClass('cart-loading');
      //console.log("ajax_cart_content removed2")*/
    })
    .fail(() => {
      // some error handling
    });
  },
  updateGiftProducts: function(rewardBlocks) {
    //console.log('updateGiftProducts function called');
   
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
         $('.ajax_cart_content').removeClass('cart-loading');
         //console.log("ajax_cart_content removed3")
        const { total_price, item_count, items } = cart;
        const cartAmount = total_price / 100;

        let milestones = rewardBlocks.map(block => block.settings.order_milestone);
        milestones.sort((a, b) => a - b);

        rewardBlocks.forEach(block => {
          const settings = block.settings;
          const rewardType = settings.reward_type;
          const basedOn = settings.discount_based_on;
          const currentValue = basedOn === 'cart_qty' ? item_count : cartAmount;

          const achievedMilestones = milestones.filter(ms => currentValue >= ms);

          let largestBlock = null;
          const archivedMilestoneBlocks = rewardBlocks.filter(b => achievedMilestones.includes(b.settings.order_milestone));

          if (archivedMilestoneBlocks.length > 1) {
            largestBlock = archivedMilestoneBlocks.sort((a, b) => b.settings.order_milestone - a.settings.order_milestone)[0];
          } else {
            largestBlock = archivedMilestoneBlocks[0];
          }

          if (rewardType === "free_gift" && getActUserCookie('isACTUser')) {
           
            if (largestBlock) {
              const freeProductVariant = largestBlock.settings.free_product;

              if (freeProductVariant) {
                const productProperties = { "Rewards": "Free Gift" };
                const data = {
                  items: [{
                    id: freeProductVariant,
                    quantity: 1,
                    properties: productProperties
                  }]
                };

                const matchingCartItems = items.filter(item => item.variant_id === freeProductVariant);
                let hasGiftProperty = matchingCartItems.some(item => item.properties?.Rewards === "Free Gift");
                if (matchingCartItems.length > 0) {
                  if (hasGiftProperty) {
                    //console.log('✅ Free gift is already in the cart with the correct property.');
                  } else {
                    //console.log('⚠️ Free product is in the cart but not marked as a gift.');
                      $('.ajax_cart_content').addClass('cart-loading');
                      //console.log("ajax_cart_content added4")
                    fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(data)
                    })
                      .then(response => response.json())
                      .then(updatedCart => {
                        //console.log('✅ Free product re-added to cart with correct gift property.', updatedCart);
                        // (Optional) Reload or re-render cart UI here if needed
                        window.PXUTheme.jsAjaxCart.updateView();
                         $('.ajax_cart_content').removeClass('cart-loading');
                         //console.log("ajax_cart_content removed5")
                      })
                      .catch(error => {
                        console.error('❌ Error re-adding free gift to cart:', error);
                         $('.ajax_cart_content').removeClass('cart-loading');
                         //console.log("ajax_cart_content removed6")
                      });
                  }
                } else {
                  const otherGiftItem = items.find(item => item.properties?.Rewards === "Free Gift");

                  if (otherGiftItem) {
                    const lineToRemove = otherGiftItem.key;
                    $('.ajax_cart_content').addClass('cart-loading');
                    //console.log("ajax_cart_content added7")
                    fetch('/cart/change.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ id: lineToRemove, quantity: 0 })
                    })
                      .then(response => response.json())
                      .then(() => {
                        //console.log('✅ Removed old gift product, now adding correct free gift variant.');
                        setTimeout(function(){
                          $('.ajax_cart_content').removeClass('cart-loading');
                         //console.log("ajax_cart_content removed8")
                        }, 1000);
                        return fetch('/cart/add.js', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify(data)
                        });
                      })
                      .then(response => response.json())
                      .then(updatedCart => {
                        //console.log('✅ Free product added to the cart:', updatedCart);
                        window.PXUTheme.jsAjaxCart.updateView();
                        /* $('.ajax_cart_content').removeClass('cart-loading');
                         //console.log("ajax_cart_content removed8")*/
                      })
                      .catch(error => {
                        console.error('❌ Error updating cart:', error);
                         $('.ajax_cart_content').removeClass('cart-loading');
                         //console.log("ajax_cart_content removed9")
                      });

                  } else {
                    //console.log('🆕 Free gift is not in the cart. Adding it now...');
                      $('.ajax_cart_content').addClass('cart-loading');
                      //console.log("ajax_cart_content added10")
                    fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(data)
                    })
                      .then(response => response.json())
                      .then(updatedCart => {
                        //console.log('✅ Free product added to the cart:', updatedCart);
                        window.PXUTheme.jsAjaxCart.updateView();
                         $('.ajax_cart_content').removeClass('cart-loading');
                         //console.log("ajax_cart_content removed11")
                      })
                      .catch(error => {
                        console.error('❌ Error adding free gift to cart:', error);
                         $('.ajax_cart_content').removeClass('cart-loading');
                         //console.log("ajax_cart_content removed12")
                      });
                  }
                }
              }
            } else {
              // No milestone met, remove existing gift if any
              const otherGiftItem = items.find(item => item.properties?.Rewards === "Free Gift");

              if (otherGiftItem) {
                const lineToRemove = otherGiftItem.key;
                $('.ajax_cart_content').addClass('cart-loading');
                //console.log("ajax_cart_content added13")
                fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: lineToRemove, quantity: 0 })
                })
                  .then(response => response.json())
                  .then(() => {
                    //console.log('✅ Removed old gift product (no milestone met).');
                    window.PXUTheme.jsAjaxCart.updateView();
                     $('.ajax_cart_content').removeClass('cart-loading');
                     //console.log("ajax_cart_content removed14")
                  })
                  .catch(error => {
                    console.error('❌ Error removing gift from cart:', error);
                     $('.ajax_cart_content').removeClass('cart-loading');
                     //console.log("ajax_cart_content removed15")
                  });
              }
            }
          }
          else
          {
             // 🚫 Not ACT user → remove any free gift
            const giftItems = items.filter(item => item.properties?.Rewards === "Free Gift");

            if (giftItems.length > 0) {
              $('.ajax_cart_content').addClass('cart-loading');

              // Remove all free gifts in parallel
              Promise.all(
                giftItems.map(gift =>
                  fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: gift.key, quantity: 0 })
                  })
                )
              )
                .then(() => {
                  window.PXUTheme.jsAjaxCart.updateView();
                  $('.ajax_cart_content').removeClass('cart-loading');
                })
                .catch(err => {
                  console.error('❌ Error removing free gifts:', err);
                  $('.ajax_cart_content').removeClass('cart-loading');
                });
            } else {
              $('.ajax_cart_content').removeClass('cart-loading');
            }
                     //console.log("ajax_cart_content removed155")
          }
          //console.log('Last archived milestone block:', largestBlock);
        });
      })
      .catch(error => {
        console.error('❌ Error fetching cart.js:', error);
      });
  },
  unload: function ($section) {
  //console.log('unload function called');
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}
function updateMultiRewardsBar(rewardBlocks) {
  //console.log('updateMultiRewardsBar function called');
  let milestones = [];

  // Extract all milestone values
  rewardBlocks.forEach(block => {
    const milestoneValueRaw = parseFloat(block.settings.order_milestone);
    const milestoneValue = parseFloat(milestoneValueRaw.toFixed(2));
    milestones.push(milestoneValue);
  });

  milestones.sort((a, b) => a - b);
  const maxMilestone = Math.max(...milestones);

  // Fetch the cart data before the loop
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const { total_price, item_count, items } = cart;
      const cartAmount = total_price / 100;
      
      // Now loop through each reward block
      rewardBlocks.forEach(function (block) {
        const activeRewards = block.settings;
        const rewardType = activeRewards.reward_type;

        const basedOn = activeRewards.discount_based_on;
        const currentValue = basedOn === 'cart_qty' ? item_count : cartAmount;

        // ✅ Determine achieved milestones
        const achievedMilestones = milestones.filter(ms => currentValue >= ms);
        const nextMilestone = milestones.find(ms => currentValue < ms);
        const highestMilestone = Math.max(...milestones);
        // //console.log('achievedMilestones',achievedMilestones);
        // //console.log('nextMilestone',nextMilestone);
        // //console.log('highestMilestone',highestMilestone);

        // ✅ Select message block
        let messageBlock;
        if (nextMilestone) {
          messageBlock = rewardBlocks.find(b => b.settings.order_milestone == nextMilestone);
        } else {
          messageBlock = rewardBlocks.find(b => b.settings.order_milestone == highestMilestone);
        }

        // ✅ Progress bar update
        let progressPercent = (currentValue / maxMilestone) * 100;
        // //console.log('progressPercent',progressPercent);
        // //console.log('currentValue',currentValue);
        progressPercent = Math.min(progressPercent, 100);
        const progressBars = document.querySelectorAll('.rewards-progress');
        progressBars.forEach((bar) => {
          bar.style.width = `${progressPercent}%`;
        });

        // ✅ Update tier containers
        const tierContainers = document.querySelectorAll('.rewards-tiers-container');
        tierContainers.forEach((container) => {
          // console.log(container);
          const milestoneValue = parseFloat(container.dataset.blockMilstone);
          // console.log(container.dataset.blockMilstone);
          // console.log('milestoneValue',milestoneValue);
          if (achievedMilestones.includes(milestoneValue)) {
            container.classList.add('active');
          } else {
            container.classList.remove('active');
          }
        });

        // ✅ Update progress message
        const messageElements = document.querySelectorAll('.progress-message');
        // console.log('messageBlock',messageBlock);
        // console.log('messageElements.length',messageElements.length);
        if (messageElements.length > 0 && messageBlock) {
          messageElements.forEach((messageElement) => {
            let message = '';
            const milestone = messageBlock.settings.order_milestone;
// console.log('current milestone',milestone);
// console.log('current cartAmount',cartAmount);
            if (basedOn === 'cart_qty') {
              if (item_count >= milestone) {
                message = messageBlock.settings.text_after_reward_met
                  .replace("REWARD", messageBlock.settings.reward_text);
              } else {
                const remaining = milestone - item_count;
                message = messageBlock.settings.text_before_reward_met
                  .replace("AMOUNT", remaining)
                  .replace("REWARD", messageBlock.settings.reward_text);
              }
            } else {
              if (cartAmount >= milestone) {
                message = messageBlock.settings.text_after_reward_met
                  .replace("REWARD", messageBlock.settings.reward_text);
              } else {
                const remaining = milestone - cartAmount;
                message = messageBlock.settings.text_before_reward_met
                  .replace("AMOUNT", ShopifyCurrency.symbol + remaining.toFixed(2))
                  .replace("REWARD", messageBlock.settings.reward_text);
              }
            }

            messageElement.innerHTML = message;
          });
        }
      });
    })
    .catch(error => {
      console.error('❌ Error fetching cart.js:', error);
    });
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function renderCrossSellProductElement(crossSellProducts) {
  //console.log('renderCrossSellProductElement function called');
  // console.log(crossSellProducts);
  const crossSellContainers = document.querySelectorAll(".cross-sell-products-container");

  if (crossSellContainers.length > 0) {

    const productWrapper = document.createElement('div');
    productWrapper.classList.add('cross-sell-product-wrapper');
    
    // Start slider container
    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('cross-sell-slider');

    // Render all cross-sell products in the slider
    crossSellProducts.forEach(product => {
      const sliderElement = document.createElement('div');
      sliderElement.classList.add('slick_slide');
      const productElement = document.createElement('div');
      productElement.classList.add('cross-sell-product');
      
      productElement.innerHTML = `
        <img src="${product.image}" alt="${product.title}" class="cross-sell-product-image">
        <div class="cross-sell-product_content">
          <h4 class="cross-sell-product-title">${product.title}</h4>
          <div class="cross-sell-price-with-cta">
            <p class="cross-sell-product-price">${product.price}</p>
            <button class="add-to-cart-cross-sell-button" data-variant-id="${product.variantId}">
              ${window.PXUTheme.translation.addToCart}
            </button>
          </div>
        </div>
      `;
      
      sliderElement.appendChild(productElement);
      sliderContainer.appendChild(sliderElement);
    });

    // Append the slider container to the wrapper
    productWrapper.appendChild(sliderContainer);

    crossSellContainers.forEach(container => {
      container.appendChild(productWrapper.cloneNode(true));
    });

    // 🔹 Init/re-init slick after appending
    initOrReinitCrossSellSliders();

    // Add event listeners for "Add to Cart" buttons
    const addToCartCrossSellButtons = document.querySelectorAll('.add-to-cart-cross-sell-button');
    addToCartCrossSellButtons.forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const productVariantId = e.target.getAttribute('data-variant-id');
        if (productVariantId) {
          addToCartCrossSell(productVariantId);
        }
      });
    });
  } else {
    //console.log('crossSellContainers not found!');
  }
}
function initOrReinitCrossSellSliders() {
    //console.log('initOrReinitCrossSellSliders function called');
  const $sliders = jQuery('.cross-sell-slider');

  $sliders.each(function () {
    const $slider = jQuery(this);
    // If already initialized, destroy first
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    // (Re)initialize slick
    $slider.slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev">Previous</button>',
      nextArrow: '<button type="button" class="slick-next">Next</button>',
      responsive: [
        {
          breakpoint: 600,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        }
      ]
    });
  });
}

function addToCartCrossSell(productVariantId) {
  //console.log('addToCartCrossSell function called');
   $('.ajax_cart_content').addClass('cart-loading');
  const formData = {
    items: [{
      id: productVariantId,  // Add the variant ID
      quantity: 1      // Quantity to add (adjust as needed)
    }]
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => response.json())
    .then(data => {
      //console.log('product added');
      if(rewardBlocks){
      window.PXUTheme.jsAjaxCart.updateGiftProducts(rewardBlocks);
    }
      window.PXUTheme.jsAjaxCart.updateView();
       $('.ajax_cart_content').removeClass('cart-loading');

    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
}
function getActUserCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}


/******/ })()
;